const GTM_CONTAINER_ID = "GTM-WVNG9WC";

export const googleTagManager = (): void => {
  const w = window as typeof window & { dataLayer: Record<string, unknown>[] };
  const d = document;
  const l = "dataLayer";

  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const f = d.getElementsByTagName("script")[0];
  const j = d.createElement("script");
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  f.parentNode!.insertBefore(j, f);
};

export const googleTagManagerPostScript = (): void => {
  const bodyTag = document.body;
  const noScriptTag = document.createElement("noscript");
  const iFrame = document.createElement("iframe");
  iFrame.src = `https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`;
  iFrame.height = "0";
  iFrame.width = "0";
  iFrame.style.cssText = "display:none;visibility:hidden";
  bodyTag.appendChild(noScriptTag);
  noScriptTag.appendChild(iFrame);
};
